var React = require('react');

function CircleArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 21.6a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2zM8.1 11.1a.9.9 0 1 0 0 1.8h5.508l-2.52 2.34a.9.9 0 1 0 1.224 1.32l4.2-3.9a.898.898 0 0 0 0-1.32l-4.2-3.9a.9.9 0 1 0-1.224 1.32l2.52 2.34H8.1z","fill":"#fff"}));
}

CircleArrowRight.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = CircleArrowRight;

CircleArrowRight.default = CircleArrowRight;
